import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Question from './Question';
import questionsData from '../questions.json';

function TestPage() {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const scoreRef = useRef(0);
  const [key, setKey] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const shuffled = [...questionsData.questions].sort(() => 0.5 - Math.random());
    setSelectedQuestions(shuffled.slice(0, 30));
    const source = document.referrer.startsWith(window.location.origin) ? 'home' : 'external';
    window.gtag?.('event', 'test_start', { source });
  }, []);

  const handleAnswer = (isCorrect) => {
    if (isCorrect) {
      scoreRef.current += 1;
    }
    window.gtag?.('event', 'question_answered', {
      question_number: currentQuestionIndex + 1,
      question_id: selectedQuestions[currentQuestionIndex].question_number,
      is_correct: isCorrect,
      current_score: scoreRef.current
    });
  };

  const nextQuestion = () => {
    if (currentQuestionIndex < 29) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setKey(prevKey => prevKey + 1);
    } else {
      const finalScore = scoreRef.current;
      window.gtag?.('event', 'test_complete', {
        final_score: finalScore,
        score_percentage: ((finalScore / 30) * 100).toFixed(2)
      });
      navigate('/score', { state: { score: finalScore } });
    }
  };

  if (selectedQuestions.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="font-body text-ink-muted">Laden...</p>
      </div>
    );
  }

  const progress = ((currentQuestionIndex + 1) / 30) * 100;

  return (
    <div className="min-h-screen">
      {/* Progress bar */}
      <div className="fixed top-0 left-0 right-0 h-1 bg-border z-50">
        <div
          className="h-full bg-accent transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="max-w-2xl mx-auto px-6 py-8 animate-fade-in">
        {/* Question counter */}
        <div className="flex items-baseline justify-center gap-2 mb-6">
          <span className="font-display font-semibold text-3xl text-ink">
            {currentQuestionIndex + 1}
          </span>
          <span className="font-body text-ink-muted">
            van 30
          </span>
        </div>

        {/* Question component */}
        <Question
          key={key}
          question={selectedQuestions[currentQuestionIndex]}
          onAnswer={handleAnswer}
          onNext={nextQuestion}
        />
      </div>
    </div>
  );
}

export default TestPage;